module.exports = __webpack_public_path__ + "static/media/8_r_derevo1_93.02_61.3.d872ea2a.png";